import { IconType, SvgIcon } from './SvgIcon';

export const SubtitlesIcon: IconType = (props) => (
  <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path
      d="M19 5H5C3.89543 5 3 5.89543 3 7V17C3 18.1046 3.89543 19 5 19H19C20.1046 19 21 18.1046 21 17V7C21 5.89543 20.1046 5 19 5Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 15H11M15 15H17M7 11H9M13 11H17"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

SubtitlesIcon.displayName = 'SubtitlesIcon';
